export default __webpack_public_path__ + "static/media/lionel_messi_2.569900d4.jpg";